import omit from 'lodash/omit';
import { videoFileFactory, } from '@core/hydration/videoFile';
export const actions = {
    set_id(value) {
        this.encoded_id = value;
        return this;
    },
    cta_type(value) {
        this.action_type = value;
        return this;
    },
    cta_url(value) {
        this.action_url = value;
        return this;
    },
    set_download_url(value) {
        this.download_url = value;
        return this;
    },
    add_video_file(callback) {
        if (!this.video_files) {
            this.video_files = [];
        }
        const videoFile = videoFileFactory(callback);
        this.video_files.push(videoFile);
        return this;
    },
};
/**
 * @returns An Api_Video object patch containing hydrated data.
 */
export const videoFactory = (callback) => {
    const video = Object.create(actions);
    callback === null || callback === void 0 ? void 0 : callback(video);
    return omit(video, Object.keys(actions));
};
